import React from 'react';
import {Badge} from "react-bootstrap";

export const YearBadge = ({children}) => (<Badge variant={children === new Date().getFullYear() ? 'primary': 'light'}>{children}</Badge>);
